module.exports = "/static/assets/d2d3ca006dd41ad8f0dd3d2e69eedf73.png";